import { render } from "./ConfirmarConta.vue?vue&type=template&id=30be4edd&scoped=true"
import script from "./ConfirmarConta.vue?vue&type=script&lang=js"
export * from "./ConfirmarConta.vue?vue&type=script&lang=js"

import "./ConfirmarConta.vue?vue&type=style&index=0&id=30be4edd&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30be4edd"]])

export default __exports__